import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import getCleanUrl from 'helpers/getCleanUrl'
import isExternalUrl from 'helpers/isExternalUrl'

import { ChevronRightIcon } from '@pleio/icons/chevron-right'
import { NewWindowSmallIcon } from '@pleio/icons/new-window-small'

import Accordeon from 'js/components/Accordeon'
import { Col } from 'js/components/Grid'

import styles from './DirectLinks.module.css'

const DirectLinks = () => {
    const { t } = useTranslation()

    const { data } = useQuery<any>(DIRECT_LINKS)
    const { site } = data || {}

    if (!site || !site.directLinks || site.directLinks.length === 0) {
        return null
    }

    const items = site.directLinks.map((item, index) => {
        const url = getCleanUrl(item.link)
        const isExternal = isExternalUrl(url)
        const LinkElement = isExternal ? 'a' : Link

        return (
            <LinkElement
                key={'item' + index}
                className={styles.wrapper}
                to={!isExternal ? url : null}
                href={isExternal && url}
                target={isExternal ? '_blank' : null}
                rel={isExternal ? 'noopener noreferrer' : null}
                aria-label={`${item.title}${
                    isExternal ? t('global.opens-in-new-window') : ''
                }`}
            >
                <div className={styles.linkItemTitle}>{item.title}</div>
                <div className={styles.linkItemIcon}>
                    {isExternal ? <NewWindowSmallIcon /> : <ChevronRightIcon />}
                </div>
            </LinkElement>
        )
    })

    return (
        <Col mobileLandscape={1 / 2} tablet={1 / 2}>
            <Accordeon title={t('widget-direct-links.title')}>
                {items}
            </Accordeon>
        </Col>
    )
}

const DIRECT_LINKS = gql`
    query DirectLinks {
        site {
            guid
            directLinks {
                title
                link
            }
        }
    }
`

export default DirectLinks
